<template>
  <div class="profitReport">
    <datePicker   @dateChange="dateChange($event)" :currentMonth="currentMonth"></datePicker>
    <div v-show="isNewRule" class="checked-row">
        <van-checkbox @change="checkBoxChange" v-model="checked" checked-color="#1fadf6">显示本期数、本年累计数</van-checkbox>
    </div>
    <div v-if="arrDataAll.length == 0" class="empty">
        <img src="../../assets/images/bnodata.png" alt="">
        <div class="desc">暂无数据</div>
    </div>
    <ul v-else class="ulList itemBox">
        <li v-if="isNewRule && checked" class="titleList"><span>项目</span><span>本期数</span><span>本年累计数</span></li>
        <li v-if="isNewRule && !checked" class="titleList"><span>项目</span><span>本期金额</span><span>上期金额</span></li>
        <li v-if="!isNewRule" class="titleList"><span>项目</span><span>本年累计金额</span><span>本月金额</span></li>
        <ul v-for="item in arrDataAll" :key="item.id">
            <li v-if='item.detail' class="collapseList">
                <van-collapse v-model="activeName" accordion >
                    <van-collapse-item :name="item.id">
                        <div slot="title">
                            <span>{{item.name}}</span>
                            <span :class="item.balance<'0'&&item.balance!=''?'abnormal':''">{{item.balance || '- -'}}</span>
                            <span :class="item.prebalance<'0'&&item.prebalance!=''?'abnormal':''">{{item.prebalance || '- -'}}</span>
                        </div>
                        <div  v-for="itemChild in item.detail" :key="itemChild.id">
                            <span>{{itemChild.name}}</span>
                            <span :class="itemChild.balance<'0'&&itemChild.balance!=''?'abnormal':''">{{itemChild.balance || '- -'}}</span>
                            <span :class="itemChild.prebalance<'0'&&itemChild.prebalance!=''?'abnormal':''">{{itemChild.prebalance || '- -'}}</span>
                        </div>
                    </van-collapse-item>    
                </van-collapse>
            </li>
            <li v-else :class="item.colour=='1'?'itemBox':''">
                <span>{{item.name}}</span>
                <span :class="item.balance<'0'&&item.balance!=''?'abnormal':''">{{item.balance || '- -'}}</span>
                <span :class="item.prebalance<'0'&&item.prebalance!=''?'abnormal':''">{{item.prebalance || '- -'}}</span>
            </li>
        </ul>
    </ul>
  </div>
</template>

<script>
import Vue from 'vue'
import { Collapse, CollapseItem, Toast, Checkbox } from 'vant';
import moment from 'moment'
import DatePicker from '@/components/DatePicker.vue'
Vue.use(Collapse).use(CollapseItem).use(Toast).use(Checkbox);
export default {
  name: 'profitReport',
  components: {
    DatePicker
  },
  data () {
    return {
        activeName:['1'],
        currentMonth:'',
        curDate:'',
        company:'流沙网络科技有限公司',
        arrDataAll:[],
        data:[],
        checked:false,
        isNewRule:false,
        fromAcctCustomerInfo:this.$store.state.fromAcctCustomerInfo,
    }
  },
  props: {
    msg: String,
  },
  mounted() {
    if(this.$store.state.accountDate){
        this.curDate = this.$store.state.accountDate
        this.currentMonth =  `${this.$store.state.accountDate.substr(0,4)}-${this.$store.state.accountDate.substr(4,2)}`
    }else if(this.$route.query.customer.period){
        this.curDate = this.$route.query.customer.period.replace('-','');
        this.currentMonth =  `${this.$route.query.customer.period.replace('-','').substr(0,4)}-${this.$route.query.customer.period.replace('-','').substr(4,2)}`
    }else{
        this.curDate = new Date().getFullYear() + ((new Date().getMonth() + 1) >= 10 ? (new Date().getMonth() + 1) : ("0" + (new Date().getMonth() + 1)))
        this.currentMonth =  new Date().getFullYear() + "-" + ((new Date().getMonth() + 1) >= 10 ? (new Date().getMonth() + 1) : ("0" + (new Date().getMonth() + 1)))
    }
    this. getType();
    this.getData();
  },
  methods: {
    getType(){
        let url = Object.keys(this.fromAcctCustomerInfo).length > 0 ? ('/fc/small/program/getsystem?dbId=' + this.fromAcctCustomerInfo.databaseId + '&companyId=' + this.fromAcctCustomerInfo.companyId) : '/fc/small/program/getsystem'
        this.$http.get(url).then((response) => {
            if (response.data.code === 200) {
               if(response.data.data.system == 'CHS.NewAcct' || response.data.data.system == 'CHS.NXQY_2019' || response.data.data.system == 'CHS.YXQY_2019'){
                    this.isNewRule = true
               }else{
                    this.isNewRule = false
               }
            } else {
                this.$toast(response.data.msg)   
            }
        }).catch(error => {
          this.$toast(error)
        });
    },
    getData(){
        Toast.loading({mask: true,message: '加载中...'});
        let param = Object.keys(this.fromAcctCustomerInfo).length > 0 ? (`?&yearperiod=${this.curDate}&type=1&periodParm=${this.checked ? 1 : 0}&dbId=${this.fromAcctCustomerInfo.databaseId}&companyId=${this.fromAcctCustomerInfo.companyId}`) : (`?&yearperiod=${this.curDate}&type=1&periodParm=${this.checked ? 1 : 0}`)
        this.$http.get('/fc/small/program/reportprofit'+param,).then((response) => {
            Toast.clear();
            if (response.data.code === 200) {
                this.data = response.data.data.items
                this.arrDataAll = [];
                this.data.forEach((element,index) => {
                    element.name = element.name.replace(/&nbsp;/ig, '')
                    if(index == 0){
                        element.colour = 0;
                    }
                    if(element.minLow == 0){
                        this.arrDataAll.push(element)
                    }else{
                        if(this.arrDataAll[this.arrDataAll.length-1].detail){
                            this.arrDataAll[this.arrDataAll.length-1].detail.push(element)
                        }else{
                            this.arrDataAll[this.arrDataAll.length-1].detail = [];
                            this.arrDataAll[this.arrDataAll.length-1].detail.push(element)
                        }
                    }
                    
                });
            } else {
                this.arrDataAll = [];
                this.$toast(response.data.msg)   
            }
        });
    },
    checkBoxChange(){
        this.getData();
    },
    dateChange(data){
        this.curDate = moment(data).format('YYYYMM')
        this.getData();
        let year =  data.split("-")[0];
        let month = data.split("-")[1] >= 10
            ? parseInt(data.split("-")[1])
            : parseInt(data.split("-")[1].slice(1))
        this.currentMonth =  year + '-' + (month >=10 ? month : ('0' + month));
    }
    
  },
}
</script>

<style lang="stylus" scoped>
.empty {
  text-align: center;
  padding-top: 1.4rem;
  background: #F0F2F2;
  img{
    width:0.8rem;
  }
  .desc {
    margin-top: 0.08rem;
    color: #B4BEC7;
    font-size:0.12rem;
  }
}
.profitReport{
    background-color:#fff;
    .ulList{
        text-align:center;
        .titleList{
            font-size:.16rem;
            color:#2C3E50; 
            font-weight:bold;   
        }
        li span{
            display:inline-block;
            padding:12px 0;
        }
        li span:nth-child(1){
            width: 1.18rem;
            text-align:left;
            box-sizing:border-box;
        }
        li span:nth-child(2){
            width: 1.16rem;
        }
        li span:nth-child(3){
            width: 1.09rem;
        }
        .collapseList span:nth-child(1){
            padding-left:.12rem;    
        }
    }
    .curDate{
        text-align:center;
        padding:.12rem 0;
    }
    .company{
        text-align:center;
        color:#8896A4;
        padding:8px 0;    
    }
    .itemBox{
        border-top:10px solid #F0F2F2;
    }
    .abnormal{
        color:red; 
    }

}
</style>
<style lang="stylus" >
    .profitReport{
        .van-cell__right-icon{
            position:absolute;   
            right:.1rem; 
            top:.12rem;
        }
        .van-cell ,.van-collapse-item__content{
            padding:0;
        }
        .van-collapse-item__content{
            background-color:#F9FBFC;    
        }
        .van-cell__right-icon{
            color:#1fadf6;
        }
        .checked-row{
            padding 0.12rem
            border-top 0.1rem solid #f0f2f2
        }

    }
</style>

